import { putContactoCtasBancarias } from "api/Contacto.service"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import notification from "common/utils/notification"
import { useTranslation } from "react-i18next"
import { CuentaBancariaContactoWithLogoProps } from "./CardBankAcountContact"

export const useMarkPrincipalCuentaBancariaContactos = (
  id: string,
  contactosCuentaBancariaByIdRefetch: () => void
) => {
  const { t } = useTranslation()

  const markPrincipal = async (
    bankAccount: CuentaBancariaContactoWithLogoProps
  ) => {
    try {
      const adaptedData = {
        id: bankAccount.id,
        cuentaBancaria: {
          ...bankAccount,
          principal: true,
        },
      }

      const resp = await putContactoCtasBancarias({
        id,
        idCuentaBancaria: bankAccount.id ?? "",
        requestBody: adaptedData,
      })

      if (resp.status === STATUSCORRECT) {
        contactosCuentaBancariaByIdRefetch()
        notification.success({
          body: `${t("contactos.cuentasBancarias.editSuccess")}`,
        })
        contactosCuentaBancariaByIdRefetch()
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error marcando como principal:", error)
    }
  }
  return { markPrincipal }
}
